<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "RoleSettingView"
}
</script>

<style scoped>

</style>